import React, { useMemo } from 'react';
import { classes } from './ComplexPhone.st.css';
import { Autocomplete } from 'wix-ui-tpa';
import { COUNTRIES_CODES, } from '@wix/forms-common/dist/src/locale-dataset/country-codes';
import { getCountryByShortKey } from '@wix/locale-dataset-javascript';
import { objectToSortedArray } from './utils';
import ReactCountryFlag from 'react-country-flag';
export const CountryCodeAutoComplete = ({ invalidMessage, disabled, theme, countryCode, onCountryCodeChange, translateMessage, }) => {
    const [showFlag, setShowFlag] = React.useState(false);
    const renderCountryFlag = (countryShortName, options = {}) => {
        if (!showFlag && !options.forceShow) {
            return null;
        }
        return (React.createElement("div", { style: { marginLeft: options.withLeftMargin ? '5px' : '' } },
            React.createElement(ReactCountryFlag, { countryCode: countryShortName, svg: true })));
    };
    const renderCountryOption = (country) => {
        return (React.createElement("div", { className: classes.countryOption },
            renderCountryFlag(country.shortname, {
                withLeftMargin: false,
                forceShow: true,
            }),
            React.createElement("span", null, country.shortname),
            React.createElement("span", null, country.prefix)));
    };
    const countriesInfo = useMemo(() => {
        const countries = Object.keys(COUNTRIES_CODES).reduce((acc, key) => {
            acc[key] = {
                shortname: key,
                prefix: COUNTRIES_CODES[key],
                displayName: translateMessage({
                    type: getCountryByShortKey(key).displayName,
                    context: { externalId: '' },
                }),
            };
            return acc;
        }, {});
        return objectToSortedArray(countries).map((code) => ({
            id: code.key,
            value: `${code.value.shortname};${code.value.displayName};${code.value.prefix}`,
            isSelectable: true,
            isDisabled: false,
            displayText: code.value.prefix,
            render: () => renderCountryOption(code.value),
        }));
    }, []);
    const getValueParts = (valueString) => {
        const [countryShortName, displayName, prefix] = valueString.split(';');
        return { countryShortName, prefix, displayName };
    };
    const initialOption = countriesInfo.find((o) => {
        return o.id === countryCode;
    });
    const searchForRelevantCountry = (searchValue) => {
        const searchValueUpper = searchValue.toUpperCase();
        return countriesInfo.find((country) => {
            return country.value.includes(searchValueUpper);
        });
    };
    return (React.createElement("div", { className: classes.autoCompleteWrapper },
        React.createElement(Autocomplete, { "data-hook": "country-code-autocomplete", className: classes.autocomplete, disabled: disabled, theme: theme, initialSelectedId: countryCode, error: !!invalidMessage, prefix: renderCountryFlag(countryCode, { withLeftMargin: true }), placeholder: initialOption === null || initialOption === void 0 ? void 0 : initialOption.displayText, onSelect: (selectedOption) => {
                const { countryShortName } = getValueParts(selectedOption.value);
                setShowFlag(true);
                onCountryCodeChange(countryShortName);
            }, onBlur: (event) => {
                if (event.target.value !== '') {
                    const possibleRelevantOption = searchForRelevantCountry(event.target.value);
                    if (possibleRelevantOption) {
                        const { countryShortName } = getValueParts(possibleRelevantOption.value);
                        onCountryCodeChange(countryShortName);
                    }
                    else {
                        onCountryCodeChange(countryCode);
                    }
                }
                else {
                    onCountryCodeChange(countryCode);
                }
                setShowFlag(true);
            }, onFocus: () => {
                setShowFlag(false);
            }, options: countriesInfo })));
};
//# sourceMappingURL=CountryAutoComplete.js.map